import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed } from 'vue';

import { BaseFieldProps } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import { FieldValue, WysiwygFieldParams } from 'SharedDir/declarations/fields';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'WysiwygField' },
  __name: 'Wysiwyg',
  props: {
    label: { default: '' },
    showHistory: { type: Boolean },
    history: {},
    params: {},
    value: { default: null }
  },
  setup(__props: any) {


const props = __props;

const htmlString = computed(() => {
  if (props.value && props.value.value) {
    return props.value.value;
  }

  return props.params.text;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { innerHTML: htmlString.value }, null, 8, _hoisted_1))
}
}

})